import { Link, useLocation, useParams } from 'react-router-dom';
import './FloatingMenu.scss';
import { useEffect, useState } from 'react';

type FloatingMenuProps = {
};

function FloatingMenu(props: FloatingMenuProps) {

    const [activeTab, setActiveTab] = useState<number>(0);
    const location = useLocation();
    const params = useParams<{productId: string}>();

    useEffect(() => {
        if(location.pathname.includes('/groups')) {
            setActiveTab(1);
        }
    }, []);

    return (
        <div className="floating-menu">
            <div className={`floating-indicator active-` + activeTab}></div>
            <Link to={`/m/${params.productId}/dashboard`} onClick={() => setActiveTab(0)}><span className={`floating-menu-button ` + (activeTab === 0 ? 'active' : '')}>Dashboard</span></Link>
            <Link to={`/m/${params.productId}/groups`} onClick={() => setActiveTab(1)}><span className={`floating-menu-button ` + (activeTab === 1 ? 'active' : '')}>Groups</span></Link>
        </div>
    );
}

export default FloatingMenu;
